module.exports = __webpack_public_path__ + "media/views/reviews/images/star-fill-615b0618832c16390fca22d3441607c0.svg";